import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import streetReadAction from './streetRead.action.json' assert { type: 'json' }

const streetReadDefinition = defineReadAutoAction(streetReadAction, 'street')

export default streetReadDefinition
